/**
 * PR-CORE-01 — Product Runtime Truth / Release Truth types.
 *
 * Single machine-readable authority for product/release truth. Every capability
 * state is one of a fixed enum so UI, docs and release gates can never invent
 * their own wording or stronger claims than this authority allows.
 *
 * Read-only: no execution, no network, no secrets.
 */
/** Environment scopes a capability claim can be made for. */
export const PRODUCT_RUNTIME_ENVIRONMENTS = [
    "local",
    "ci",
    "staging",
    "production",
    "real_device",
];
/** Fixed capability runtime states. UI/docs must render exactly these. */
export const CAPABILITY_RUNTIME_STATES = [
    "LIVE",
    "APPROVAL_REQUIRED",
    "PREVIEW",
    "DISABLED",
    "OWNER_ACTION_REQUIRED",
    "NOT_CONFIGURED",
    "BLOCKED",
];
/** What kind of evidence backs a claim. */
export const RELEASE_EVIDENCE_KINDS = [
    "code_inspection",
    "unit_test",
    "integration_test",
    "ci_run",
    "staging_deploy",
    "production_deploy",
    "real_device_proof",
    "owner_signoff",
];
/**
 * A machine-verifiable claim that evidence bound to `evidenceSha` applies to
 * the truth's source as well — used only when the two snapshots differ by a
 * deterministic non-runtime delta (e.g. docs-only commits such as AGENTS.md
 * log rotation). The SHA classification itself is computed by the repo gate /
 * generator from git; this model only records the resulting claim so the
 * committed artifact can be re-verified. Never fabricate: without a claim,
 * cross-SHA evidence stays unbound.
 */
export const RUNTIME_EQUIVALENCE_REASONS = ["docs-only-delta"];
export const RUNTIME_TRUTH_EQUIVALENCE_CLASSES = [
    "current_head",
    "executable_source_ancestor_equivalent",
    "executable_delta",
    "diverged",
    "unknown_source",
    "tree_content_equivalent",
];
//# sourceMappingURL=productRuntimeTruthTypes.js.map